import { gql } from '@apollo/client';

export const LOAD_HOME_PAGE_BLOGS = gql`
  query {
    blogs(sort: "publishedDate:DESC", pagination: { pageSize: 3 }) {
      data {
        attributes {
          mainImage {
            data {
              attributes {
                url
                formats
              }
            }
          }
          blogTags {
            data {
              attributes {
                label
              }
            }
          }
          title
          slug
          publishedDate
          shortDescription
          isFullWidth
        }
      }
    }
  }
`;

export const LOAD_ARTICLE = gql`
  query ($slug: String) {
    blogs(filters: { slug: { eq: $slug } }, pagination: { pageSize: 1 }) {
      data {
        id
        attributes {
          mainImage {
            data {
              attributes {
                url
                formats
                height
                width
              }
            }
          }
          blogTags {
            data {
              attributes {
                slug
                label
              }
            }
          }
          title
          author
          createdBy
          slug
          publishedDate
          pageContent
          shortDescription
          isFullWidth
          createdBy
          seo {
            metaTitle
            metaDescription
            metaImage {
              data {
                attributes {
                  url
                }
              }
            }
            keywords
          }
        }
      }
    }
  }
`;

export const BLOG_ITEMS_LIST = gql`
  query BlogsItemsList($pageSize: Int!, $page: Int!) {
    blogs(pagination: { pageSize: $pageSize, page: $page }) {
      data {
        attributes {
          slug
        }
      }
    }
  }
`;

const blogDataQuery = `
data {
  id
  attributes {
    mainImage {
      data {
        attributes {
          url
          formats
        }
      }
    }
    blogTags {
      data {
        attributes {
          slug
          label
        }
      }
    }
    title
    author
    createdBy
    slug
    publishedDate
    shortDescription
  }
}
`;

export const LOAD_BLOGS = gql`
  query ($limit: Int!, $start: Int!, $slug: String = null) {
    blogs(
      sort: "publishedDate:DESC"
      pagination: { limit: $limit, start: $start }
      filters: { slug: { ne: $slug } }
    ) {
      data {
        id
        attributes {
          mainImage {
            data {
              attributes {
                url
                formats
              }
            }
          }
          blogTags {
            data {
              attributes {
                slug
                label
              }
            }
          }
          title
          author
          createdBy
          slug
          publishedDate
          shortDescription
        }
      }
    }
  }
`;

export const BLOGS_BY_TAG = gql`
  query ($limit: Int!, $page: Int!, $tag: String!, $sort: [String]) {
    blogs(
      sort: $sort
      pagination: { pageSize: $limit, page: $page }
      filters: {blogTags: {slug: { eq: $tag }}}
    ) {
      ${blogDataQuery}
      meta {
        pagination {
          page
          pageCount
        }
      }
    }
  }
`;

export const SEARCH_BLOGS = gql`
  query SearchBlogBySearchString($limit: Int!, $page: Int!, $search: String!, $sort: [String]) {
    blogs(
      sort: $sort
      pagination: { pageSize: $limit, page: $page }
      filters: {
        or: [
          { title: { containsi: $search } }
          # TODO - make search by content
          # { pageContent: { containsi: $search } }
        ]
      }
    ) {
      ${blogDataQuery}
      meta {
        pagination {
          page
          pageCount
        }
      }
    }
  }
`;

export const TAG_BY_SLUG = gql`
  query ($slug: String!) {
    findSlug(modelName: "blog-tag", slug: $slug) {
      ... on BlogTagEntityResponse {
        data {
          attributes {
            label
          }
        }
      }
    }
  }
`;

export const GET_BLOGS_BY_SLUG_LIST = gql`
  query ($slugList: [String]!) {
    blogs(filters: { slug: { in: $slugList } }) {
      data {
        attributes {
          slug
          title
          mainImage {
            data {
              attributes {
                url
                formats
              }
            }
          }
        }
      }
    }
  }
`;

export const LOAD_PREVIEW_ARTICLE = gql`
  query ($slug: String, $unsavedChangeId: ID) {
    blogs(
      filters: { slug: { eq: $slug } }
      pagination: { pageSize: 1 }
      publicationState: PREVIEW
    ) {
      data {
        id
        attributes {
          mainImage {
            data {
              attributes {
                url
              }
            }
          }
          blogTags {
            data {
              attributes {
                slug
                label
              }
            }
          }
          title
          slug
          publishedDate
          pageContent
          shortDescription
          isFullWidth
        }
      }
    }
    previewButtonUnsavedChange(id: $unsavedChangeId) {
      data {
        attributes {
          data
        }
      }
    }
  }
`;
